import { NotifyHelper } from "../../../helpers/toast";
import { eTietThiActionsObj } from "../../action-types/tct/ITietThiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const tietThiActions = {
    ...generateActions(eTietThiActionsObj, "TIET_THI"),
    ...generateActionForKey(eTietThiActionsObj, "TIET_THI", "SAVE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eTietThiActionsObj, "TIET_THI", "DELETE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eTietThiActionsObj, "TIET_THI", "SAVE_ERROR", (m) => NotifyHelper.Error(m)),
    ...generateActionForKey(eTietThiActionsObj, "TIET_THI", "DELETE_ERROR", (m) => NotifyHelper.Error(m)),
};
